import Vue from 'vue';
import VueRouter from 'vue-router';
import cam from './cam';
import NotAuthGuard from "./not_auth_guard";

Vue.use(VueRouter);

let routes = [
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/Login'),
        breadcrumbs: [],
        beforeEnter: NotAuthGuard,
    },
    {
        path: '/',
        redirect: {name: 'login'}
    }
];

routes = routes.concat(cam);

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

export default router
